// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SuggestedContentSidebar-cls1___821607b4aedce02530e{/*!*/}.SuggestedContentSidebar-cls2___a2067802093eb78507c{flex-grow:1;color:#223}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "SuggestedContentSidebar-cls1___821607b4aedce02530e",
	"cls2": "SuggestedContentSidebar-cls2___a2067802093eb78507c SuggestedContentSidebar-cls1___821607b4aedce02530e"
};
export default ___CSS_LOADER_EXPORT___;
